<div class="card border-0 shadow-sm mb-4 position-relative">
  <div class="page-disable-overlay bg-dark opacity-50 position-absolute w-100 h-100 top-0 start-0">
  </div>
  <div class="card-header bg-success bg-gradient text-white">
    <h5 class="card-title mb-0">
      <i class="fa fa-book me-2"></i>
      Course Management
    </h5>
  </div>
  <div class="card-body">
    <form class="row g-3">
      <div class="col-12 col-md-6">
        <label class="form-label fw-semibold">Default Course Duration (minutes)</label>
        <input type="number" class="form-control" placeholder="45">
      </div>
      <div class="col-12 col-md-6">
        <label class="form-label fw-semibold">Pass Score Percentage</label>
        <input type="number" class="form-control" placeholder="80" min="0" max="100">
      </div>
      <div class="col-12">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="allowRetakes">
          <label class="form-check-label" for="allowRetakes">
            Allow Course Retakes
          </label>
        </div>
      </div>
      <div class="col-12">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="requireSequentialProgress">
          <label class="form-check-label" for="requireSequentialProgress">
            Require Sequential Course Progress
          </label>
        </div>
      </div>
      <div class="col-12">
        <button type="submit" class="btn btn-success">
          <i class="fa fa-save me-1"></i>
          Save Course Settings
        </button>
      </div>
    </form>
  </div>
</div>
